





















import VueOptions from '@utils/VueOptions'
import WizardService from '@services/Wizard'
import StepContainer from '@ui/AudienceSetWizard/StepContainer'
import PartnershipSteps from '@ui/AudienceSetWizard/PartnershipStep/PartnershipSteps'

settings =
  name: 'PartnershipOverviewStep'

  vue:
    props: ['wizard', 'step']
    mixins: [WizardService.step()]

    components: {
      StepContainer,
      PartnershipSteps,
    }

    computed:
      categories: -> [
        'kombucha',
        'coconut_water',
        'sparkling_water',
      ]

      prohibited_categories: -> [
        'alcohol',
        'tobacco',
      ]

export default VueOptions.vue settings
